export const stepTitles = {
  0: 'Name & Filters',
  1: 'Data included',
};
